const { abstractResource } = require("./abstractResource");

const service = abstractResource("NOTIFICATIONS");

const EmailTemplate = {
  ...service("emails/templates"),
  get_params_transaction() {
    return {
      client_name: { text: "nom_part_ent", value: null },
      billing_contact_last_name: { text: "nom_contact_factu", value: null },
      billing_contact_first_name: { text: "prenom_contact_factu", value: null },
      delivery_contact_last_name: { text: "nom_contact_livr", value: null },
      delivery_contact_first_name: { text: "prenom_contact_livr", value: null },
      expiration_date: { text: "date_expiration", value: null },
      delivery_date: { text: "date_livraison", value: null },
      tracking: { text: "suivi_coli", value: null },
      billing_address: { text: "adresse_factu", value: null },
      delivery_address: { text: "adresse_livr", value: null },
      total: { text: "total", value: null },
      left_to_pay: { text: "reste_a_payer", value: null },
      transaction_link: { text: "lien_transaction", value: null },
    };
  },
};

const Category = {
  ...service("emails/categories"),
};

const Notifications = {
  ...service("notifications")
}

module.exports = {
  EmailTemplate,
  Category,
  Notifications,
};
